import { Component, OnInit } from '@angular/core';

declare var $: any;
@Component({
  selector: 'lawvu-gdrive-sync',
  templateUrl: './lawvu-gdrive-sync.component.html',
  styleUrls: ['./lawvu-gdrive-sync.component.css']
})
export class LawVuGdriveSyncComponent implements OnInit {
  successMessage : string = "";

  constructor() { }

  ngOnInit() {
  }

  showModal():void {
    $("#notificationModal").modal('show');
  }
  hideModal():void {
    $("#notificationModal").modal('hide');
    this.successMessage = "";
  }

}
